var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlightIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 14,
    viewBox: "0 0 23 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6845 1.08493C16.7904 1.5377 15.4011 2.412 13.8331 3.42681L6.32285 2.24026C5.90139 2.17127 5.4718 2.20534 5.06289 2.34018L3.43292 2.86476C3.29537 2.86476 3.29537 3.02088 3.43292 3.08333L9.7052 6.20584C7.58693 7.64219 5.7025 8.95364 4.8772 9.54692C4.72994 9.65191 4.56407 9.71867 4.39143 9.74242C4.2188 9.76617 4.04367 9.74633 3.87858 9.68431L2.23624 9.09415C1.97544 8.98858 1.69035 8.98969 1.43019 9.09728L0.393066 9.57814L3.85933 12.8568C4.03358 13.0227 4.24553 13.1295 4.47084 13.1648C4.69614 13.2002 4.92567 13.1627 5.13304 13.0566C6.78914 12.2167 11.1495 9.93723 14.3957 8.01689C21.6033 3.67661 22.4011 2.92721 22.4011 2.24026C22.4011 1.163 19.6514 0.0545064 17.6845 1.08493Z",
    fill: "#BDBDBD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlightIcon);
export default __webpack_public_path__ + "static/media/flight_icon.143fa747.svg";
export { ForwardRef as ReactComponent };